<template>
  <div class="skeleton-placeholder">
    <div class="skeleton-placeholder__tags-list">
      <div
        v-for="tagIndex in numberOfItems"
        :key="`skeleton-placeholder__tags-item-${tagIndex}`"
        class="skeleton-placeholder__tags-item"
      />
    </div>

    <div class="skeleton-placeholder__columns-list">
      <div
        v-for="columnIndex in numberOfItems"
        :key="`skeleton-placeholder__columns-item-${columnIndex}`"
        class="skeleton-placeholder__columns-item"
      >
        <div
          v-for="dealCardIndex in 4"
          :key="`skeleton-placeholder__deal-card-${dealCardIndex}`"
          class="skeleton-placeholder__deal-card"
        >
          <div class="skeleton-placeholder__deal-card__title" />

          <div class="skeleton-placeholder__deal-card__summary">
            <div class="skeleton-placeholder__deal-card__type" />
            <div class="skeleton-placeholder__deal-card__owner" />
            <div class="skeleton-placeholder__deal-card__price" />
          </div>

          <div class="skeleton-placeholder__deal-card__tags">
            <div
              v-for="dealCardTagIndex in 3"
              :key="`skeleton-placeholder__deal-card__tags-item-${dealCardTagIndex}`"
              class="skeleton-placeholder__deal-card__tags-item"
            />
          </div>

          <div class="skeleton-placeholder__deal-card__counters">
            <div
              v-for="dealCardCounterIndex in 4"
              :key="`skeleton-placeholder__deal-card__counters-item-${dealCardCounterIndex}`"
              class="skeleton-placeholder__deal-card__counters-item"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GETTER } from '@/store/CONSTANTS';

export default {
  name: 'SkeletonPlaceholder',
  data() {
    return {
      numberOfItems: this.$store.getters[GETTER.USER.USER_TYPE] === 'partner' ? 12 : 6,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.skeleton-placeholder {
  width: auto;
  overflow: hidden;
  margin-left: -$sp-m + -$sp-xs;
  padding-left: $sp-m + $sp-xs;

  &__tags-list,
  &__columns-list {
    display: flex;
  }

  &__columns-list {
    margin-top: $sp-m + $sp-xs;
  }

  &__tags-item {
    flex-shrink: 0;
    height: 40px;
    width: 200px;
    margin-right: $sp-s;
    border-radius: 8px;
    background-color: getShade($quaternary-color, 50);
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;

    @include for('tablet') {
      height: 56px;
      width: 368px;
      margin-right: $sp-m;
    }

    @include for('desktop-wide') {
      width: 432px;
      margin-right: $sp-l + $sp-s;
    }
  }

  &__columns-item {
    flex-shrink: 0;
    height: 100%;
    margin-right: $sp-s;

    @include for('tablet') {
      margin-right: $sp-m;
    }

    @include for('desktop-wide') {
      margin-right: $sp-l + $sp-s;
    }
  }

  &__deal-card {
    flex-shrink: 0;
    border-radius: 8px;
    box-shadow: 0px 0px 24px rgba(26, 27, 60, 0.16);
    margin-bottom: $sp-m;
    padding: $sp-m;
    width: 368px;

    @media (max-width: 375px) {
      width: calc(100vw - $sp-l - $sp-s);
    }

    @include for('desktop') {
      margin-bottom: $sp-m + $sp-s;
    }

    @include for('desktop-wide') {
      width: 432px;
    }

    &__title,
    &__type,
    &__owner,
    &__price,
    &__tags-item {
      background-color: getShade($quaternary-color, 50);
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }

    &__title {
      height: 30px;
      border-radius: 4px;
    }

    &__type {
      width: 20px;
      height: 20px;
      border-radius: 10px;
    }

    &__owner,
    &__price {
      height: 16px;
      border-radius: 4px;
    }

    &__owner {
      width: 60%;
    }

    &__price {
      width: 30%;
    }

    &__summary,
    &__tags,
    &__counters {
      display: flex;
      align-items: center;
      margin-top: $sp-s;

      > :not(:first-child) {
        margin-left: $sp-s;
      }
    }

    &__tags-item {
      margin-top: $sp-xs;
      height: 20px;
      border-radius: 8px;

      &:first-of-type {
        width: 30%;
      }
      &:nth-of-type(2) {
        width: 50%;
      }
      &:nth-of-type(3) {
        width: 20%;
      }
    }

    &__counters-item {
      margin-top: $sp-s;
      height: 16px;
      width: 33%;
      display: flex;
      border-radius: 4px;
      background-color: getShade($quaternary-color, 50);
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}
</style>
